import React from 'react';

import PrimaryButton from '../../../partials/customButtons/PrimaryButton';
import SecondaryButton from '../../../partials/customButtons/SecondaryButton';
import { translate } from '../../../i18n/I18nProvider';

const ActionsButtons = ({ onCloseClick, handleSubmit }) => {
  return (
    <>
      <SecondaryButton onClick={onCloseClick}>
        {translate('BUTTON.CANCEL')}
      </SecondaryButton>
      {
        <PrimaryButton onClick={handleSubmit}>
          {translate('SPLIT')}
        </PrimaryButton>
      }
    </>
  );
};

export default ActionsButtons;
